import classNames from 'classnames';
import { useGlobalContext } from '~/context/GlobalContext';
import styles from './Notification.module.css';
import { inherits } from 'util';

interface NotificationProps {
  roomId: string;
  count?: number;
  className?: string;
}

function Notification (props: NotificationProps) {
  const { roomId, count = 0, className } = props;
  const { context } = useGlobalContext();

  const isActive = context.room?.id === roomId && context.activeSidebarId === '';
  
  if (count <= 0 || isActive) {
    return null;
  }

  return (
    <div 
      data-component="Notification" 
      className={classNames(styles.notification, className)}
    >
      {count > 99 ? '99+' : count}
    </div>
  );
};

export default Notification;